import { reportDateLabel } from '@/entities/report/report.model'

export const reportColumns = [
  { key: 'number', label: 'Report / ID', value: row => row.number },
  {
    key: 'location',
    label: 'Asset / site',
    value: row => row.assetLabel + ' ' + row.siteLabel
  },
  { key: 'type', label: 'Report type', value: row => row.type },
  {
    key: 'date',
    label: 'Report date',
    value: row => reportDateLabel(row.date)
  },
  {
    key: 'technique',
    label: 'Inspection technique',
    value: row => row.techniques.join(' · ') || 'Not recorded'
  }
]
